<template>
  <div>
    <van-overlay
      v-model:show="state"
      class="off-dialog"
      @click="handleClose"
    >
      <div class="wrapper flex justify-center align-center">
        <div class="dialog_wrap">
          <div class="cover_pg_title">
            <span>Tips:</span>
            <van-icon class="close-icon" name="cross" size="14" color="#CCCCCC" @click="handleClose" />
          </div>
          <div class="cover_pg__text mt_10">The Keyword {{ wordListShow }} has been successfully covered.<span class="cover_pg__id">(Order ID: <span @click="jumpKeywordAcq">{{ order._id }}</span>)</span></div>
          <div class="cover_pg__text">The ranking will most likely get lost without promotion. It is better to select Keywords Install Package to hold and boost your ranking postion.</div>
          <div class="cover_pg__btn_group">
            <van-button class="cover_pg__btn" @click="jumpKeywordInstall(50, 5)">50 Installs*5 Days</van-button>
            <van-button class="cover_pg__btn" @click="jumpKeywordInstall(200, 5)">200 Installs*5 Days</van-button>
            <van-button class="cover_pg__btn" @click="jumpKeywordInstall(500, 5)">500 Installs*5 Days</van-button>
          </div>
        </div>
        
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { ref } from '@vue/reactivity'
import { computed, onMounted, watch } from '@vue/runtime-core'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'


export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default: () => {}
    },
    wordList: {
      type: Array,
      default: () => [] 
    }
  },
  setup(props){
    const store = useStore()
    const router = useRouter()
    const state = ref(false)
    watch(
      () => props.visible,
      (nVal) => {
        console.log(nVal)
        state.value = nVal
      },
      { deep: true}
    )
    const wordListShow = computed(()=>{
      return props.wordList.join(',')
    })

    const jumpKeywordAcq = () => {
      window.open(`/wap/order?type=keyword&orderId=${props.order._id}`, '_blank')
      state.value = false
    }

    const jumpKeywordInstall = async (isDJ, D) => {
        
      await store.commit('dashboard/setAcquOrderId', props.order._id)
      router.push({
        path: '/wap/empty',
        query: {
          jumpRouter: '/wap/campaign',
          jumpParams: JSON.stringify({
            isDialogJump: isDJ,
            appId: props.order.appId,
            platform: props.order.platform,
            region: props.order.region,
            serviceType: 'KEYWORD_INSTALL',
            wordList: props.wordList,
            notShowHeader: true,
            jumpDay: D
          })
        }
      })
      state.value = false
    }

    const handleClose = () => {
      state.value = false
    }

    onMounted(() => {
      state.value = props.visible
    })
    
    return {
    //   ...toRefs(state),
      state,
      wordListShow,
      jumpKeywordAcq,
      jumpKeywordInstall,
      handleClose
    }
  }
}
</script>

<style lang="scss" scoped>

.mt_10 {
    margin-top: 10px;
}

.off-dialog {
    z-index: 10099;

    .wrapper {
      width: 100%;
      height: 100%;
    }
  }

.dialog_wrap {
    width: 70%;
    background-color: #fff;
    border-radius: 8px;
    padding: 20px 35px;

    &>p{
        word-break: break-word;
    }

    .cover_pg_title {
        font-size: 16px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #1E183F;
        display: flex;
        justify-content: space-between;
    }

    .cover_pg__text {
        margin-bottom: 10px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #1E183F;

        &>.cover_pg__id {
            margin-left: 5px;
            color: #6153FF;

            &>span {
                &:hover {
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
        }
    }

    .cover_pg__btn_group {
        margin-top: 30px;
        text-align: center;

        .cover_pg__btn {
            display: inline-block;
            width: 60%;
            height: 40px;
            margin-bottom: 16px;
            border-radius: 4px 4px 4px 4px;
            color: #6153FF;
            border: 1px solid #6153FF;

            &:hover {
                background-color: #E7E5FC;
            }
        }
    }
}
</style>
